import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";

const websiteAnalysisStorageProvider = createModuleStorage(localStorage, "si:website-analysis");

export default websiteAnalysisStorageProvider;
